import { render } from "./createpermission.vue?vue&type=template&id=6a6c538c"
import script from "./createpermission.vue?vue&type=script&lang=js"
export * from "./createpermission.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__